import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@involves/violin"
      }}><img alt="npm package" src="https://img.shields.io/npm/v/@involves/violin/latest.svg" /></a>{`
`}<a parentName="p" {...{
        "href": "https://circleci.com/gh/involvestecnologia/violin/tree/master"
      }}><img alt="CircleCI" src="https://img.shields.io/circleci/project/github/involvestecnologia/violin/master.svg" /></a>{`
`}<a parentName="p" {...{
        "href": "https://app.netlify.com/sites/violin-ui/deploys"
      }}><img alt="Netlify Status" src="https://api.netlify.com/api/v1/badges/e51f2c75-0c37-4fec-9814-95cdd188a532/deploy-status" /></a></p>
    <h1 {...{
      "id": "overview"
    }}>{`Overview`}</h1>
    <p>{`Violin is a components library to build UI faster with React.`}</p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`//with yarn
yarn add styled-components @involves/violin

// with npm
npm install styled-components @involves/violin
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><inlineCode parentName="p">{`styled-components`}</inlineCode>{` is required`}</p>
    </blockquote>
    <h2 {...{
      "id": "open-sans-font"
    }}>{`Open Sans font`}</h2>
    <p>{`Violin was designed with the Open Sans font in mind. You can load via Google Web Fonts:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Open+Sans:400,600,700&display=swap" />
`}</code></pre>
    <h2 {...{
      "id": "font-icons"
    }}>{`Font Icons`}</h2>
    <p>{`In order to use the font Icon component, you must first add the `}<a parentName="p" {...{
        "href": "https://material.io/tools/icons/"
      }}>{`Material icons`}</a>{` font with `}<em parentName="p">{`Round`}</em>{` and `}<em parentName="p">{`Outlined`}</em>{` style. You can load via Google Web Fonts:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons+Round|Material+Icons+Outlined" />
`}</code></pre>
    <h2 {...{
      "id": "global-styles-recomended"
    }}>{`Global styles (recomended)`}</h2>
    <p><inlineCode parentName="p">{`GlobalStyle`}</inlineCode>{` component adds global setting styles as default font family, font sizes, colors and `}<a parentName="p" {...{
        "href": "https://necolas.github.io/normalize.css/"
      }}>{`normailze`}</a>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { GlobalStyle } from "@involves/violin";

const App = () => {
  return (
    <>
      <GlobalStyle />
      { /** */ }
    </>
  )
}
`}</code></pre>
    <h2 {...{
      "id": "using-components"
    }}>{`Using components`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Button } from "@involves/violin";

<Button>Enjoy!</Button>
`}</code></pre>
    <p>{`or you can import individual components. This way you don't load all library to using only some component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Button } from "@involves/violin/lib/components/Button";

<Button>Enjoy!</Button>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      